var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4816 15.7037C17.6867 15.7 16.9282 16.0371 16.3983 16.6296L8.29643 12.5926C8.29643 12.5 8.29643 12.3981 8.29643 12.2963L16.4261 7.37034C17.3269 8.36134 18.8065 8.56852 19.9448 7.86305C21.0832 7.15758 21.5561 5.74033 21.0695 4.49264C20.5829 3.24495 19.2753 2.52208 17.9599 2.77357C16.6445 3.02506 15.6959 4.17929 15.7038 5.51849C15.705 5.73046 15.7299 5.94165 15.7779 6.14812L7.57421 11.074C6.74892 10.1608 5.42105 9.8996 4.31136 10.4322C3.20166 10.9648 2.5748 12.1642 2.77104 13.3793C2.96727 14.5945 3.9398 15.5356 5.16073 15.6918C6.38167 15.848 7.55982 15.1821 8.05569 14.0555L15.7686 17.9074C15.7245 18.0955 15.7028 18.2882 15.7038 18.4815C15.7038 20.0156 16.9475 21.2592 18.4816 21.2592C20.0157 21.2592 21.2594 20.0156 21.2594 18.4815C21.2594 16.9473 20.0157 15.7037 18.4816 15.7037Z",
    fill: "#464646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare24);
export default __webpack_public_path__ + "static/media/share24.6ac69fcd0ac7ac1776e44dbac3ca1199.svg";
export { ForwardRef as ReactComponent };